import { render, staticRenderFns } from "./AssetTableEdit.vue?vue&type=template&id=482efc01&"
import script from "./AssetTableEdit.vue?vue&type=script&lang=js&"
export * from "./AssetTableEdit.vue?vue&type=script&lang=js&"
import style0 from "./AssetTableEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports